import { ConnectionStatus, Network } from '@capacitor/network';
import { useEffect, useState } from 'react';

export function useIsOnline(): boolean {
  const [isOnline, setIsOnline] = useState<boolean>(true);

  async function setInitialOnlineStatus() {
    try {
      const initial = await Network.getStatus();

      setIsOnline(initial.connected);
    } catch (error) {
      console.error('Error getting network status:', error);
    }
  }

  useEffect(() => {
    // Set the initial value
    setInitialOnlineStatus();

    // Add a listener for the change
    const listener = Network.addListener('networkStatusChange', (status: ConnectionStatus) => {
      if (import.meta.env.MODE !== 'production') console.log('Network status changed', status);

      setIsOnline(status.connected);
    });

    return () => {
      listener.then((subscription) => subscription.remove());
    };
  }, []);

  return isOnline;
}
